import { render, staticRenderFns } from "./CommonSubheader.vue?vue&type=template&id=21580caa&scoped=true&"
import script from "./CommonSubheader.vue?vue&type=script&lang=ts&"
export * from "./CommonSubheader.vue?vue&type=script&lang=ts&"
import style0 from "./CommonSubheader.vue?vue&type=style&index=0&id=21580caa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21580caa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow,VSpacer})
